import ApiClient from "./apiClient";
import { QueriesApi } from "./apiTypes";

const hypervisorService = {
  getHypervisors: (queries: QueriesApi) => ApiClient.get('openstack/hypervisors', {
    params: {
      page: queries.page,
      page_size: queries.pageSize ?? queries.page_size,
      ordering: queries.ordering,
      search: queries.search,
      filtering: queries.filtering,
    }
  }),
  getHypervisorById: (id: string) => ApiClient.get(`openstack/hypervisors/${id}`),
}

export default hypervisorService;
